import React from "react";
import { C } from "../constants/appConstants";
import "./ui.css";

function joinClasses(...classes){
  return classes.filter(Boolean).join(" ");
}

function ActionIcon({name="arrow-right",size=18,className=""}){
  const common={
    width:size,
    height:size,
    viewBox:"0 0 24 24",
    fill:"none",
    stroke:"currentColor",
    strokeWidth:"1.8",
    strokeLinecap:"round",
    strokeLinejoin:"round",
    "aria-hidden":"true",
    className:joinClasses("dw-action-icon",`dw-action-icon--${name}`,className)
  };

  const paths={
    "arrow-right":<><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></>,
    "arrow-left":<><path d="M19 12H5"/><path d="m11 6-6 6 6 6"/></>,
    "chevron-down":<path d="m7 9.5 5 5 5-5"/>,
    "chevron-up":<path d="m7 14.5 5-5 5 5"/>,
    plus:<><path d="M12 5v14"/><path d="M5 12h14"/></>,
    minus:<path d="M5 12h14"/>,
    check:<path d="m5 12 4 4L19 6"/>,
    close:<><path d="m6 6 12 12"/><path d="m18 6-12 12"/></>,
    edit:<><path d="M4 20h4L19 9l-4-4L4 16v4Z"/><path d="m13.5 6.5 4 4"/></>,
    trash:<><path d="M4 7h16"/><path d="M9 7V4h6v3"/><path d="m7 7 1 13h8l1-13"/><path d="M10 11v5M14 11v5"/></>,
    refresh:<><path d="M20 7v5h-5"/><path d="M4 17v-5h5"/><path d="M6.1 9a7 7 0 0 1 11.7-2L20 9"/><path d="m4 15 2.2 2a7 7 0 0 0 11.7-2"/></>,
    copy:<><rect x="9" y="9" width="11" height="11" rx="2"/><path d="M15 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h3"/></>,
    download:<><path d="M12 3v12"/><path d="m7 10 5 5 5-5"/><path d="M5 21h14"/></>,
    archive:<><path d="M4 7h16v13H4z"/><path d="M3 4h18v3H3z"/><path d="M9 11h6"/></>,
    clock:<><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></>,
    alert:<><path d="M12 3 2.5 20h19L12 3Z"/><path d="M12 9v5"/><path d="M12 17h.01"/></>,
    send:<><path d="m22 2-7 20-4-9-9-4Z"/><path d="M22 2 11 13"/></>,
    chat:<><path d="M21 11.5a8.2 8.2 0 0 1-9 8 9.4 9.4 0 0 1-4-.9L3 21l1.4-4.2A8.2 8.2 0 1 1 21 11.5Z"/></>,
    bell:<><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9"/><path d="M10 21h4"/></>,
    home:<><path d="m3 11 9-8 9 8"/><path d="M5 10v10h14V10"/><path d="M9 20v-6h6v6"/></>,
    building:<><rect x="4" y="3" width="16" height="18" rx="2"/><path d="M8 7h2M14 7h2M8 11h2M14 11h2M8 15h2M14 15h2M10 21v-3h4v3"/></>,
    shirt:<><path d="m8 4-5 3 3 5 2-1v9h8v-9l2 1 3-5-5-3a4 4 0 0 1-8 0Z"/></>,
    clipboard:<><rect x="5" y="4" width="14" height="17" rx="2"/><path d="M9 4.5V3h6v1.5M9 9h6M9 13h6M9 17h4"/></>,
    package:<><path d="m4 7 8-4 8 4-8 4-8-4Z"/><path d="m4 7 8 4v10l-8-4V7ZM20 7l-8 4v10l8-4V7Z"/><path d="m8 5 8 4"/></>,
    mail:<><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></>,
    phone:<><path d="M7 3H4a1 1 0 0 0-1 1c0 9.4 7.6 17 17 17a1 1 0 0 0 1-1v-3l-4-2-2 2c-3.5-1.4-6.2-4.1-7.5-7.5l2-2L7 3Z"/></>,
    card:<><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 10h18"/><path d="M7 15h4"/></>,
    tag:<><path d="M20 13 13 20 4 11V4h7l9 9Z"/><path d="M8.5 8.5h.01"/></>,
    user:<><circle cx="12" cy="8" r="4"/><path d="M4.5 21a7.5 7.5 0 0 1 15 0"/></>,
    settings:<><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1-2.8 2.8-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.6v.2h-4V21a1.7 1.7 0 0 0-1-1.6 1.7 1.7 0 0 0-1.9.3l-.1.1L4.2 17l.1-.1a1.7 1.7 0 0 0 .3-1.9A1.7 1.7 0 0 0 3 14H3v-4h.1a1.7 1.7 0 0 0 1.6-1 1.7 1.7 0 0 0-.3-1.9L4.2 7 7 4.2l.1.1A1.7 1.7 0 0 0 9 4.6a1.7 1.7 0 0 0 1-1.6V3h4v.1a1.7 1.7 0 0 0 1 1.6 1.7 1.7 0 0 0 1.9-.3l.1-.1L19.8 7l-.1.1a1.7 1.7 0 0 0-.3 1.9 1.7 1.7 0 0 0 1.6 1h.1v4H21a1.7 1.7 0 0 0-1.6 1Z"/></>,
    search:<><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/></>,
    eye:<><path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"/><circle cx="12" cy="12" r="2.5"/></>,
    repeat:<><path d="m17 2 4 4-4 4"/><path d="M3 11V9a3 3 0 0 1 3-3h15"/><path d="m7 22-4-4 4-4"/><path d="M21 13v2a3 3 0 0 1-3 3H3"/></>,
    "eye-off":<><path d="M3 3l18 18"/><path d="M10.6 10.6a2 2 0 0 0 2.8 2.8"/><path d="M9.9 4.2A10.8 10.8 0 0 1 12 4c5.5 0 9 5 9 8a12 12 0 0 1-2.1 3.7"/><path d="M6.6 6.6C4.3 8 3 10.4 3 12c0 3 3.5 8 9 8 1.3 0 2.5-.3 3.6-.8"/></>
  };

  return <svg {...common}>{paths[name]||paths["arrow-right"]}</svg>;
}

function inferActionIcon(label){
  const text=typeof label==="string"||typeof label==="number"?String(label).trim():"";
  if(!text) return "";
  // Labels that already include a leading action symbol must not receive a duplicate inferred icon.
  if(/^[+←✓]/.test(text)) return "";
  if(/카카오|문의/.test(text)) return "chat";
  if(/엑셀|다운로드|내보내기/.test(text)) return "download";
  if(/메일/.test(text)) return "mail";
  if(/전화/.test(text)) return "phone";
  if(/복사/.test(text)) return "copy";
  if(/삭제/.test(text)) return "trash";
  if(/보관|아카이브/.test(text)) return "archive";
  if(/새로고침|갱신|불러오기|재사용|재발주|초기화|다시 시도/.test(text)) return "refresh";
  if(/발송|보내기|전달/.test(text)) return "send";
  if(/취소|닫기|해제/.test(text)) return "close";
  if(/지연|경고|확인 필요/.test(text)) return "alert";
  if(/진행중|처리 중/.test(text)) return "clock";
  if(/저장|완료|읽음|선택|정리|입고 확인|입금 처리/.test(text)) return "check";
  if(/수정|조정|직접 입력/.test(text)) return "edit";
  if(/제외/.test(text)) return "eye-off";
  if(/검색/.test(text)) return "search";
  if(/알림/.test(text)) return "bell";
  if(/설정/.test(text)) return "settings";
  if(/대시보드$/.test(text)) return "home";
  if (/^\s*←|돌아가기|이전|뒤로|로그아웃/.test(text)) return "arrow-left";
  if(/^\s*\+|추가|신규|새 발주|등록|만들기/.test(text)) return "plus";
  if(/요청|출고 처리/.test(text)) return "send";
  if(/다음|확인|보기|열기|시작|로그인|가입|이어서|재설정|변경|요금제|전환/.test(text)) return "arrow-right";
  return "";
}

const Btn=({ch,onClick,v="p",full,disabled,sz="m",className="",icon,iconPosition="end"})=>{
  const variant=v==="w"?"secondary":v==="d"?"muted":"primary";
  const size=sz==="xs"?"compact":sz==="s"?"small":sz==="l"?"large":"medium";
  const iconName=icon===false?"":typeof icon==="string"?icon:inferActionIcon(ch);
  const iconNode=React.isValidElement(icon)
    ?icon
    :iconName
      ?<ActionIcon name={iconName}/>
      :null;

  return (
    <button
      className={joinClasses(
        "dw-button",
        `dw-button--${variant}`,
        `dw-button--${size}`,
        full&&"dw-button--full",
        className
      )}
      onClick={onClick}
      disabled={disabled}
    >
      {iconNode&&iconPosition==="start"&&<span className="dw-button__icon">{iconNode}</span>}
      <span className="dw-button__label">{ch}</span>
      {iconNode&&iconPosition!=="start"&&<span className="dw-button__icon">{iconNode}</span>}
    </button>
  );
};

function FCard({children,className=""}){
  return (
    <div className={joinClasses("dw-card","dw-card--form",className)}>
      {children}
    </div>
  );
}

function FRow({label,children,last,req,className=""}){
  return (
    <div className={joinClasses("dw-form-row",last&&"dw-form-row--last",className)}>
      <div className="dw-form-row__label">
        {label}
        {req&&<span className="dw-required">*</span>}
      </div>
      <div className="dw-form-row__control">{children}</div>
    </div>
  );
}

function FInp({val,onChange,ph,type="text"}){
  const field=useUncontrolledTextValue(val,onChange);

  return (
    <input
      ref={field.inputRef}
      className="dw-form-input"
      defaultValue={field.initialValue}
      onInput={field.handleInput}
      onBlur={field.handleBlur}
      placeholder={ph}
      type={type}
    />
  );
}

const FSel=({val,onChange,children,ph})=>(
  <select
    className="dw-form-select"
    value={val||""}
    onChange={e=>onChange(e.target.value)}
  >
    {ph&&<option value="">{ph}</option>}
    {children}
  </select>
);

const Tag=({ch,c=C.acc,className=""})=>{
  const isWhite=c==="#FFFFFF";
  const isAccent=c===C.acc;
  const style={
    "--dw-tag-color":c,
    "--dw-tag-bg":isWhite
      ?"rgba(255,255,255,0.08)"
      :isAccent
        ?"#F8FAFC"
        :`${c}14`,
    "--dw-tag-border":isWhite
      ?"rgba(255,255,255,0.16)"
      :isAccent
        ?C.bdr
        :`${c}24`
  };

  return <span className={joinClasses("dw-tag",className)} style={style}>{ch}</span>;
};

const Card=({children,onClick,className=""})=>(
  <div className={joinClasses("dw-card",className)} onClick={onClick}>
    {children}
  </div>
);

const Divider=()=> <div className="dw-divider"/>;
const G=()=> <div className="dw-spacer" aria-hidden="true"/>;

const Empty=({icon,text})=>(
  <div className="dw-empty">
    <div className="dw-empty__icon">{icon}</div>
    <div className="dw-empty__text">{text}</div>
  </div>
);

function Field({label,children,req,className=""}){
  return (
    <div className={joinClasses("dw-field",className)}>
      <div className="dw-field__label">
        {label}
        {req&&<span className="dw-required">*</span>}
      </div>
      {children}
    </div>
  );
}

function useUncontrolledTextValue(val,onChange){
  const inputRef=React.useRef(null);
  const externalValue=val??"";

  React.useEffect(()=>{
    const input=inputRef.current;
    if(!input || document.activeElement===input) return;
    const nextValue=String(externalValue);
    if(input.value!==nextValue){
      input.value=nextValue;
    }
  },[externalValue]);

  function handleInput(event){
    onChange?.(event.currentTarget.value);
  }

  function handleBlur(event){
    onChange?.(event.currentTarget.value);
  }

  return {
    inputRef,
    initialValue:String(externalValue),
    handleInput,
    handleBlur
  };
}

function TxtInp({val,onChange,ph,type="text",onKeyDown,className="",inputTransform,...props}){
  const field=useUncontrolledTextValue(val,onChange);

  function handleBlur(event){
    if(!inputTransform){
      field.handleBlur(event);
      return;
    }
    const nextValue=inputTransform(event.currentTarget.value);
    if(event.currentTarget.value!==nextValue){
      event.currentTarget.value=nextValue;
    }
    onChange?.(nextValue);
  }

  return (
    <div className={joinClasses("dw-text-input",className)}>
      <input
        {...props}
        ref={field.inputRef}
        defaultValue={field.initialValue}
        onInput={field.handleInput}
        onBlur={handleBlur}
        placeholder={ph}
        type={type}
        onKeyDown={onKeyDown}
      />
    </div>
  );
}

function TxtArea({val,onChange,ph,className="",...props}){
  const field=useUncontrolledTextValue(val,onChange);

  return (
    <textarea
      {...props}
      ref={field.inputRef}
      className={className}
      defaultValue={field.initialValue}
      onInput={field.handleInput}
      onBlur={field.handleBlur}
      placeholder={ph}
    />
  );
}

function DropSel({val,onChange,children,ph,className="",disabled=false}){
  return (
    <div className={joinClasses("dw-select",className)} data-empty={!val} data-disabled={disabled||undefined}>
      <select value={val||""} onChange={e=>onChange(e.target.value)} disabled={disabled}>
        {ph&&<option value="">{ph}</option>}
        {children}
      </select>
      <span className="dw-select__caret" aria-hidden="true">∨</span>
    </div>
  );
}

function StepBar({cur,total=4}){
  return (
    <div className="dw-stepbar" aria-label={`${total}단계 중 ${cur+1}단계`}>
      {Array.from({length:total},(_,i)=>(
        <div
          key={i}
          className={joinClasses(
            "dw-stepbar__item",
            i<=cur&&"is-complete",
            i===cur&&"is-current"
          )}
        />
      ))}
    </div>
  );
}

function Sheet({title,onClose,children,z=9999,className=""}){
  return(
    <div className={joinClasses("dw-sheet",className)} style={{zIndex:z}} onClick={onClose}>
      <div className="dw-sheet__panel" onClick={e=>e.stopPropagation()}>
        <div className="dw-sheet__handle"/>
        <div className="dw-sheet__header">
          <span className="dw-sheet__title">{title}</span>
          <button className="dw-sheet__close" onClick={onClose} aria-label="닫기">✕</button>
        </div>
        {children}
      </div>
    </div>
  );
}

function LineChart({data}){
  if(!data||data.length<2){
    return <div className="dw-chart-empty">데이터 없음</div>;
  }

  const W=320;
  const H=96;
  const p=12;
  const vs=data.map(d=>d.v);
  const mn=Math.min(...vs);
  const mx=Math.max(...vs);
  const rng=mx-mn||1;
  const pts=data.map((d,i)=>[
    p+(i/(data.length-1))*(W-p*2),
    H-p-((d.v-mn)/rng)*(H-p*2)
  ]);
  const area=`M ${pts[0][0]},${H-p} ${pts.map(([x,y])=>`L ${x},${y}`).join(" ")} L ${pts[pts.length-1][0]},${H-p} Z`;

  return (
    <svg className="dw-line-chart" viewBox={`0 0 ${W} ${H}`}>
      <path d={area} fill="rgba(15,23,42,0.08)"/>
      <polyline
        points={pts.map(point=>point.join(",")).join(" ")}
        fill="none"
        stroke={C.acc}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {pts.map(([x,y],i)=><circle key={i} cx={x} cy={y} r="3.5" fill={C.acc}/>)}
    </svg>
  );
}

export {
  Btn,
  ActionIcon,
  FCard,
  FRow,
  FInp,
  FSel,
  Tag,
  Card,
  Divider,
  G,
  Empty,
  Field,
  TxtInp,
  TxtArea,
  DropSel,
  StepBar,
  Sheet,
  LineChart
};
